import styled from 'styled-components'
import { grayDark } from 'utils/style-utils'

export const BtnBox = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
  align-items: center;
  padding: 1rem;

  border-top: 1px solid ${grayDark};
`
